import { render } from "./cashback.vue?vue&type=template&id=b2c98ed4"
import script from "./cashback.vue?vue&type=script&lang=js"
export * from "./cashback.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__